export default "__VITE_ASSET__abde0e25__"